var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectIconRedLinear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3906 0.976562C12.1297 0.976562 1.36719 11.7391 1.36719 25C1.36719 38.2609 12.1297 49.0234 25.3906 49.0234C38.6516 49.0234 49.4141 38.2609 49.4141 25C49.4141 11.7391 38.6516 0.976562 25.3906 0.976562ZM6.17188 25C6.17118 22.476 6.66782 19.9765 7.6334 17.6445C8.59899 15.3124 10.0146 13.1935 11.7994 11.4087C13.5841 9.62398 15.7031 8.20837 18.0351 7.24278C20.3671 6.27719 22.8666 5.78056 25.3906 5.78125C29.6593 5.77266 33.8063 7.20295 37.1621 9.84121L10.2318 36.7715C7.59358 33.4157 6.16328 29.2687 6.17188 25ZM25.3906 44.2188C21.1219 44.2273 16.9749 42.7971 13.6191 40.1588L40.5494 13.2285C43.1877 16.5843 44.618 20.7313 44.6094 25C44.6101 27.524 44.1134 30.0235 43.1478 32.3555C42.1823 34.6876 40.7666 36.8065 38.9819 38.5913C37.1971 40.376 35.0782 41.7916 32.7461 42.7572C30.4141 43.7228 27.9147 44.2194 25.3906 44.2188Z",
    fill: "#FF5860"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIconRedLinear);
export default __webpack_public_path__ + "static/media/reject_icon_red_linear.975a8026b54f688401a75537e9d228dd.svg";
export { ForwardRef as ReactComponent };